@if ({
  activeCountry: activeCountry$ | async,
  activeLanguage: activeLanguageLabel$ | async,
  activeMeasurementSystem: activeMeasurementSystemLabel$ | async,
  userData: userData$ | async,
  editBarVisibility: editBarVisibility$ | async
}; as ctx) {
  <div class="site-context--header">
    <div class="site-context--title" data-test="site-context--trigger" (click)="toggleEditBarVisibility()">
      <mat-icon class="site-context--settings-icon" svgIcon="brightness-low"></mat-icon>
      <span
        data-test="site-context--active-country" class="site-context--active-country"
      >{{ ctx.activeCountry?.name || '' }}</span>
      <span>&#45;</span>
      <span
        data-test="site-context--active-language" class="site-context--active-language" class="site-context"
      >{{ ctx.activeLanguage || '' }}</span>
      <span>&#45;</span>
      <span
        data-test="site-context--active-measurement-system" class="site-context"
      >{{ ctx.activeMeasurementSystem }}</span>
      <mat-icon
        class="site-context--arrow-icon" svgIcon="arrow-down" [ngClass]="{opened: ctx.editBarVisibility }"
      ></mat-icon>
    </div>
    @if (ctx.userData) {
      <div class="site-context--user-info">
        {{ 'miniLogin.userGreeting' | cxTranslate: { name: ctx.userData } }}
      </div>
    }
  </div>
  @if (ctx.editBarVisibility) {
    @if ({
      measurementSystems: measurementSystems$ | async,
      countries: countries$ | async,
      languages: languages$ | async,
      language: activeLanguage$ | async,
      activeMeasurementSystem: activeMeasurementSystem$ | async
    }; as barCtx) {
      <section
        @fadeInContentByHeightOpacity
        class="site-context--edit-bar"
        data-test="site-context--edit-bar"
      >
        <ng-select
          [disabled]="!!ctx.userData"
          [clearable]="false"
          class="site-context--select"
          data-test="site-context--country-select" [items]="barCtx.countries" bindLabel="name" bindValue="isocode"
          [searchable]="true" [ngModel]="ctx.activeCountry?.isocode" (change)="changeCountry($event)"
        ></ng-select>
        <ng-select
          [clearable]="false"
          class="site-context--select"
          data-test="site-context--language-select" [items]="barCtx.languages" bindLabel="label"
          bindValue="isocode"
          [searchable]="true" [ngModel]="barCtx.language" (change)="changeLanguage($event)"
        ></ng-select>
        <ng-select
          [clearable]="false"
          class="site-context--select"
          data-test="site-context--measurement-system-select" [items]="barCtx.measurementSystems" bindLabel="name"
          bindValue="code"
          [searchable]="true"
          [ngModel]="barCtx.activeMeasurementSystem" (change)="changeMeasurementSystem($event)"

        ></ng-select>
      </section>
    }
  }
}
